import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "videoContainer",
  style: {"position":"relative"}
}
const _hoisted_2 = {
  id: "videoElement",
  autoplay: "",
  class: "m-video"
}
const _hoisted_3 = {
  id: "canvasElement",
  style: {"position":"absolute","top":"0","left":"0"}
}
const _hoisted_4 = ["src"]

import {onMounted, reactive, ref, watch} from "vue";
import {onBeforeRouteUpdate} from "vue-router";
import {useSpinner} from "@/shared/composables/SogSpinner";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import notificationService from "@/shared/services/NotificationService";
import {computed} from "vue";
import apiTest, {ApiTest} from "@/modules/Test/api";
import {Api} from "@/shared/services/api";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";
import SogGrid from "@/shared/ui/SogGrid.vue";
import SogPage from "@/shared/ui/SogPage.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'TestPage',
  setup(__props) {

const _spinner = useSpinner()
const _video = ref<InstanceType<typeof HTMLVideoElement> | null>(null)
const _mediaStream = ref<InstanceType<typeof MediaStream> | null>(null)
const _videoSourceId = ref<string | undefined>(undefined)
const _videoSources = reactive<{ id: string, label: string }[]>([])
const _photoDataUrl = ref<string | undefined>(undefined)
const _capturedPhoto = ref<Blob | null>(null)
const _videoRect = ref({width: 0, height: 0})
const _captureRect = ref({x: 0, y: 0, width: 0, height: 0})
const _test = ref("")
const _fields = {text: 'label', value: 'id'}
const _grid = ref<InstanceType<typeof SogGrid> | null>(null)

const _urlCancelation = Api.baseUrl + "/InsuranceCancelationList";
const _urlCancelationGroup = Api.baseUrl + "/InsuranceCancelationGroupList";

const _hasVideo = computed(() => {
  return navigator.mediaDevices && navigator.mediaDevices.getUserMedia
})

const _title = ref("Template")

async function p_init() {
  _title.value = "Test"
  _spinner.hide()
  if (!_hasVideo.value) {
    // Der Browser unterstützt die Kamera nicht
    notificationService.error('Der Browser unterstützt keine Kamera.')
    return;
  }
  await p_loadDevices();
}


async function onCancelationSelected(data: any) {
  console.log(await apiTest.cancelation(data?.id))
}

onMounted(async () => {
  //_spinner.show()
  await p_init()
})

onBeforeRouteUpdate(async () => {
  await p_init()
});


async function p_loadDevices() {
  if (!_hasVideo.value)
    return;
  try {
    const devices = await navigator.mediaDevices.enumerateDevices()
    _videoSources.length = 0;
    devices.forEach((device) => {
      if (device.kind === 'videoinput') {
        //front back
        if (!_videoSourceId.value && device.label.toLowerCase().includes('back')) {
          _videoSourceId.value = device.deviceId
        }
        _videoSources.push({id: device.deviceId, label: device.label})
      }
    });
    if (!_videoSourceId.value && _videoSources.length > 0) {
      _videoSourceId.value = _videoSources[0].id
    }
    _grid.value?.refresh()
  } catch (e) {
    // Bei einem Fehler beim Auflisten der Geräte
    notificationService.error('Fehler beim Auflisten der Geräte.', e)
  }
}


watch((_videoRect.value), () => {
  _captureRect.value = calcCapture(_videoRect.value)
})


function drawFrame() {

  const canvas = document.getElementById('canvasElement') as HTMLCanvasElement; // HTML-Element für das Canvas
  const context = canvas.getContext('2d');

  if (!_video.value || !context)
    return

  /*
    if(a.value.videoWidth===_video.value.videoWidth&&a.value.videoHeight===_video.value.videoHeight)
      return;
  */


  _videoRect.value.width = _video.value.videoWidth
  _videoRect.value.height = _video.value.videoHeight

  /*
    console.log(_videoRect.value)
  */

  canvas.width = _video.value.videoWidth;
  canvas.height = _video.value.videoHeight;

  // Zeichne den Rahmen auf das Canvas
  context.clearRect(0, 0, canvas.width, canvas.height);
  context.strokeStyle = 'red';
  context.lineWidth = 2;
  context.strokeRect(_captureRect.value.x, _captureRect.value.y, _captureRect.value.width, _captureRect.value.height);

  requestAnimationFrame(drawFrame);
}

async function onStart() {
  if (_videoSources.length === 0 || !(_videoSourceId.value)) {
    return
  }

  try {
    // Zugriff auf die Kamera anfordern
    const stream = await navigator.mediaDevices.getUserMedia({
      video: {
        deviceId: _videoSourceId.value,
        width: 720,
        height: 1280
      }
    })

    // Kamera erfolgreich geöffnet
    _mediaStream.value = stream;

    _video.value = document.getElementById('videoElement') as HTMLVideoElement; // HTML-Element für die Anzeige des Kamerabildes

    _video.value.srcObject = stream;
    _video.value.play();

    drawFrame()

  } catch (e) {
    notificationService.error('Fehler beim Zugriff auf die Kamera:', e);
  }

}

function takePhoto() {

  console.log("takePhoto")

  if (!_video.value)
    return
  // Erstellen eines Canvas-Elements zur Anzeige des Fotos
  const canvas = document.createElement('canvas');
  canvas.width = _video.value.videoWidth;
  canvas.height = _video.value.videoHeight;
  const context = canvas.getContext('2d');

  // Zeichnen des aktuellen Videorahmens auf das Canvas
  context?.drawImage(_video.value, 0, 0, canvas.width, canvas.height);

  // Definiere den gewünschten Bereich des Fotos (x, y, width, height)
  const cropX = _captureRect.value.x;
  const cropY = _captureRect.value.y;
  const cropWidth = _captureRect.value.width;
  const cropHeight = _captureRect.value.height;

  /*
    const croppedImage = context?.getImageData(cropX, cropY, cropWidth, cropHeight);
    canvas.width = cropWidth;
    canvas.height = cropHeight;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    context?.putImageData(croppedImage!, 0, 0);
  */

  // Das aufgenommene Foto als Daten-URL abrufen
  _photoDataUrl.value = canvas.toDataURL('image/jpeg');
// Das aufgenommene Foto als Blob speichern
  canvas.toBlob(function (blob) {
    _capturedPhoto.value = blob;
  }, 'image/jpeg');
  stopCameraAccess()
}

function stopCameraAccess() {
  if (_mediaStream.value) {
    // Stoppe den Kamera-Stream und gib die Ressourcen frei
    _mediaStream.value.getTracks().forEach(function (track: any) {
      track.stop();
    });
    _mediaStream.value = null;

    // Zusätzliche Logik nach Beenden des Kamera-Zugriffs
  }
}

async function uploadPhoto() {
  if (_capturedPhoto.value) {

    const id = await apiTest.uploadTempFile('captured-photo.jpg', _capturedPhoto.value)
    if (id) {
      await apiTest.addTempFile(id, "ff325acebf674fe6912f935ea8660891", "T9445K000359", "T9445K000359.jpg")
    }
  }
}

async function takePhoto1() {
  const input = document.getElementById('myFileInput') as HTMLInputElement; // HTML-Element für die Anzeige des Kamerabildes
  input.click()
}

async function uploadPhoto1() {
  const input = document.getElementById('myFileInput') as HTMLInputElement; // HTML-Element für die Anzeige des Kamerabildes
  if (!input.files)
    return
  if (input.files.length > 0) {
    const file = input.files[0];

    const id = await apiTest.uploadTempFile('captured-photo.jpg', file)
    if (id) {
      await apiTest.addTempFile(id, "ff325acebf674fe6912f935ea8660891", "T9445K000359", "T9445K000359.jpg")
    }
  }
}

function calcCapture(rect: { width: number, height: number }) {
  const ratio = 1.414
  const k = 0.95

  const newWidth = Math.min(rect.width * k, rect.height * k, rect.height / ratio * k, window.innerWidth * k);
  const newHeight = newWidth * ratio;


  const x = window.innerWidth < _videoRect.value.width ? (window.innerWidth - newWidth) / 2 : (rect.width - newWidth) / 2;
  return {x: x, y: (rect.height - newHeight) / 2, width: newWidth, height: newHeight};
}

function onSelect(args: any) {
  _videoSourceId.value = args.data.id
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, null, {
    default: _withCtx(() => [
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-cellphone-screenshot",
                onClick: onStart
              }),
              _createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-camera",
                onClick: takePhoto
              }),
              _createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-upload",
                onClick: uploadPhoto
              }),
              _createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-camera",
                onClick: takePhoto1
              }),
              _createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-upload",
                onClick: uploadPhoto1
              })
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, { hidden: "hidden" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("input", {
                id: "myFileInput",
                type: "file",
                accept: "image/*",
                capture: "camera"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(SogGrid, {
                ref_key: "_grid",
                ref: _grid,
                data: _videoSources,
                "on-row-selected": onSelect
              }, null, 8, ["data"])
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_test.value) + " " + _toDisplayString(_videoSources) + " " + _toDisplayString(_videoSourceId.value), 1)
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _withDirectives(_createElementVNode("video", _hoisted_2, null, 512), [
                  [_vShow, _mediaStream.value]
                ]),
                _withDirectives(_createElementVNode("canvas", _hoisted_3, null, 512), [
                  [_vShow, _mediaStream.value]
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                id: "photoElement",
                alt: "Aufgenommenes Foto",
                src: _photoDataUrl.value
              }, null, 8, _hoisted_4)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Storno-Group", -1)
            ]))]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(SogGrid, { url: _urlCancelationGroup })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Storno", -1)
            ]))]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(SogGrid, {
                url: _urlCancelation,
                onSelected: onCancelationSelected
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})